import axios from 'axios'
import config from '@/config.js'
// import exportConvert from '@/store/export.convert.js'

const API_URL = config.apiUrl
// const API_URL_CLIENTSIDE = config.apiUrlClientSide

const state = {
  tokens: [],
  binHCCOccurrences: []
}

const mutations = {
  setBinHccOccurrences(state, occurrences){
    state.binHCCOccurrences = occurrences
  },
  unsetBinHccOccurrences(state){
    state.binHCCOccurrences = []
  },
}

const getters = {
}

const actions = {
  loadBinHCCOccurrences({ commit }, data){
    commit('unsetBinHccOccurrences')
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/hccs/occurrences`, data)
        .then(r => r.data)
        .then(occurrences => {
          commit('setBinHccOccurrences', occurrences)
        })
        .then(response => {
            resolve(response)
        })
    })
  },
  loadTokensParameterBin(_, parameters){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/parameter/parameter-bin`, parameters)
        .then(response => {
          resolve(response)
        })
        .catch(() => {
          this.dispatch('addNotification', {
            type: 'danger',
            text: `Something went wrong`
          })
        })
     })
  },
  saveParameterBins(_, data){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/parameter/${data.groupId}`, data)
        .then(response => {
          resolve(response)
        })
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    })
  },
  createParameter(_, data){
    return new Promise((resolve) => {
      axios
        .post(`${API_URL}/parameter`, data)
        .then(response => {
          resolve(response)
        })
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    })
  },
  deleteGroup(_, data){
    return new Promise((resolve) => {
      axios
        .delete(`${API_URL}/${data.type}/${data.id}`)
        .then(response => {
          resolve(response)
        })
      .catch(function (error) {
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.log(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    })
  }
}

export default {
    state,
    getters,
    actions,
    mutations
}

